import React from 'react';
import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import TableProductSlNo from '../jsx/layouts/TableComponents/TableProductSlNo';
import TableOrderStatus from '../jsx/layouts/TableComponents/TableOrderStatus';
import { Link } from 'react-router-dom';
import TableBlockProduct from './TableElements/TableBlockProduct';

const renderCellButton = params => {
  const col = params.colDef;
  const { row } = params;

  return (
    <IconButton onClick={() => col?.eventFunction && col.eventFunction(row, col)}>
      {col?.icon}
    </IconButton>
  );
};

const renderProductSlNo = params => {
  const col = params.colDef;
  const { row, value } = params;

  return <TableProductSlNo row={row} col={col} value={value} />;
};

const renderOrderStatus = params => {
  const col = params.colDef;
  const { row, value } = params;

  return <TableOrderStatus row={row} col={col} value={value} />;
};

const renderOrderId = params => {
  const col = params.colDef;
  const { row, value } = params;

  return (
    <Link to={`/admin/order/details/${row?._id}`} style={{ fontWeight: 600 }}>
      {value ?? '--'}
    </Link>
  );
};

const renderTableBlock = params => {
  const col = params.colDef;
  const { row, value } = params;

  return <TableBlockProduct row={row} col={col} value={value} />;
};

const renderProductName = params => {
  const col = params.colDef;
  const { row, value } = params;

  return (
    <div>
      <img style={{ width: 50, height: 50 }} src={row?.files?.[0]?.path} /> {value}
    </div>
  );
};

export const productsTable = [
  { field: 'slNo', headerName: '#', width: 90, renderCell: renderProductSlNo },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
    renderCell: renderProductName,
  },
  {
    field: 'price',
    headerName: 'Price in ₹',
    width: 150,
  },
  {
    field: 'category',
    headerName: 'Category',
    width: 150,
  },
  {
    field: 'subCategory',
    headerName: 'Sub Category',
    width: 150,
  },
  {
    field: 'bufferingDays',
    headerName: 'Buffering Days',
    width: 100,
  },
  {
    field: 'description',
    headerName: 'Description',
    width: 150,
  },
  {
    field: 'isBlocked',
    headerName: 'Freeze',
    width: 50,
    renderCell: renderTableBlock,
  },
  {
    field: 'editIcon',
    headerName: 'Edit',
    width: 50,
    renderCell: renderCellButton,
    icon: <EditIcon />,
  },
  {
    field: 'deleteIcon',
    headerName: 'Delete',
    width: 50,
    renderCell: renderCellButton,
    icon: <DeleteIcon />,
  },
];

export const ordersTable = [
  { field: 'slNo', headerName: '#', width: 30 },
  { field: 'orderId', headerName: 'Ordered ID', width: 120, renderCell: renderOrderId },
  { field: 'orderedBatch', headerName: 'Batch', width: 200 },
  { field: 'orderedByName', headerName: 'Ordered By', width: 150 },
  { field: 'orderedOn', headerName: 'Ordered On', width: 200 },
  { field: 'expectedDeliveryDate', headerName: 'Expected Delivery Date', width: 150 },
  { field: 'deliveryTimeSlots', headerName: 'Delivery Time Slots', width: 150 },
  // { field: 'orderedItems', headerName: 'Count', width: 60 },
  { field: 'status', headerName: 'Order Status', width: 120, renderCell: renderOrderStatus },
  { field: 'Town/City', headerName: 'Town/City', width: 100 },
  { field: 'totalPrice', headerName: 'Total Price', width: 100 },
  { field: 'orderNote', headerName: 'Order Note', width: 100 },
  { field: 'paymentMethod', headerName: 'Payment Method', width: 150 },
  { field: 'paymentStatus', headerName: 'Payment Status', width: 100 },
];

export const blogsTable = [
  { field: 'slNo', headerName: '#', width: 30 },
  {
    field: 'title',
    headerName: 'Title',
    width: 300,
  },
  {
    field: 'description',
    headerName: 'Description',
    flex: 1,
  },
  {
    field: 'editIcon',
    headerName: 'Edit',
    width: 50,
    renderCell: renderCellButton,
    icon: <EditIcon />,
  },
  {
    field: 'deleteIcon',
    headerName: 'Delete',
    width: 50,
    renderCell: renderCellButton,
    icon: <DeleteIcon />,
  },
];

export const pincodesTable = [
  { field: 'slNo', headerName: '#', width: 30 },
  {
    field: 'pinCode',
    headerName: 'Pin Code',
    width: 300,
  },
  {
    field: 'shipmentPrice',
    headerName: 'Shipment Price',
    flex: 1,
  },
  {
    field: 'area',
    headerName: 'Area',
    flex: 1,
  },
  {
    field: 'editIcon',
    headerName: 'Edit',
    width: 50,
    renderCell: renderCellButton,
    icon: <EditIcon />,
  },
  {
    field: 'deleteIcon',
    headerName: 'Delete',
    width: 50,
    renderCell: renderCellButton,
    icon: <DeleteIcon />,
  },
];

export const userOrdersTable = [
  { field: 'slNo', headerName: '#', width: 30 },
  {
    field: 'title',
    headerName: 'Title',
    flex: 1,
  },
  {
    field: 'price',
    headerName: 'Price in ₹',
    width: 80,
  },
  { field: 'orderId', headerName: 'Ordered ID', width: 100 },
  { field: 'orderedOn', headerName: 'Ordered On', width: 100 },
  { field: 'expectedDeliveryDate', headerName: 'Expected Delivery Date', width: 100 },
  { field: 'status', headerName: 'Order Status', width: 120 },
];
